import React, { useState } from "react";
import RegisterMember from "../../assets/images/register/register-member.png";
import RegisterShop from "../../assets/images/register/register-shop.png";
import registerStep14 from '../../assets/images/register/register-step-1-4.svg';
import PrimaryButton from '../../components/button/PrimaryButton';
import { useNavigate } from 'react-router-dom'
import { Drawer } from '@mui/material';
import SecondaryButton from '../../components/button/SecondaryButton';
import ConditionDialog from '../../components/dialog/ConditionDialog';
import TopBanner from '../../components/layout/TopBanner';
import Cookies from '../../components/text/Cookies';
import { SearchRegister } from '../../services/Register'
import { useDispatch, useSelector } from 'react-redux';
import { setRegisterMain } from '../../features/register/RegisterMainSlice';
import { useLiff } from 'react-liff';
import { resetRegisterShop } from '../../features/register/RegisterShopSlice';
import TopLogo from '../../components/layout/TopLogo';
import Stack from "@mui/material/Stack";
import { setLoading } from '../../features/LoadingSlice';


export default function RegisterMain() {
  const store = useSelector((state) => state.registerMain)
  const [styleMember, setStyleMember] = useState(store['styleMember']);
  const [styleShop, setStyleShop] = useState(store['styleShop']);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // lineId
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  function fnSetLoading(value) {
    let tmpObj = {};
    tmpObj.loading = value;
    dispatch(setLoading(tmpObj));
  }

  React.useEffect(() => {
    getSearchRegister();
  }, []);

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterMain(tmpObj));
  }

  async function getSearchRegister() {
    try {
      fnSetLoading(true)
      const { data } = await SearchRegister(lineId)
      setIsLoading(false)
      fnSetLoading(false)
      if (+data['resultCode'] === 20000) {
        const body = data.body || {};
        if (body['memberId'] && body['survey']) {
          navigate('/member-info')
        } else if (body['memberId'] && !body['survey']) {
          navigate('/register-member-3')
        }
        else if (body['employeeId']) {
          // go MemberCardOwner
          navigate('/shop-info')
        }
      } else {
        navigate('/privacy-policy')
        // fnSetActiveImage(store['active'])
      }
    } catch (error) {
      console.log('getSearchRegister error', error)
    }

  }

  function onClickLinkCookie() {
    fnSetData('openCookieDialog', true);
  }

  function onClickNext() {
    if (!checkAllowCookie() || !store['allowCookie']) {
      navigate('/privacy-policy')
    } else {
      dispatch(resetRegisterShop());
      if (store['active'] === 1) {
        navigate('/register-member-1')
      } else if (store['active'] === 2) {
        navigate('/register-shop-1')
        // navigate('/user-products')
      }
    }
  }

  function checkAllowCookie() {
    let allowCookie;
    const allowCookieStorage = localStorage.getItem('allow_cookie')
    allowCookie = allowCookieStorage === 'true';
    return allowCookie;
  }

  function fnSetActiveImage(active) {
    if (active === 1) {
      setStyleMember('selected')
      setStyleShop('unselected')
      fnSetData('styleMember', 'selected')
      fnSetData('styleShop', 'unselected')
      fnSetData('textColorList', ['text-blue', 'text-gray']);
    } else if (active === 2) {
      setStyleMember('unselected')
      setStyleShop('selected')
      fnSetData('styleMember', 'unselected')
      fnSetData('styleShop', 'selected')
      fnSetData('textColorList', ['text-gray', 'text-blue']);
    } else {
      setStyleMember('unselected')
      setStyleShop('unselected')
      fnSetData('styleMember', 'unselected')
      fnSetData('styleShop', 'unselected')
      fnSetData('textColorList', ['text-gray', 'text-gray']);
    }
  }

  function onClickImage(active) {
    fnSetData('active', active);
    fnSetActiveImage(active)
    // if (!checkAllowCookie() || !store['allowCookie']) {
    //   fnSetActiveImage(active)
    //   navigate('/privacy-policy')
    // }
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    fnSetData('openCookieDrawer', open);
  };

  const toggleCookieDialog = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    fnSetData('openCookieDrawer', open);
  };

  function onOk(e) {
    localStorage.setItem('allow_cookie', 'true');
    fnSetData('openCookieDialog', false);
    fnSetData('openCookieDrawer', false);
    fnSetActiveImage(store['active']);
  }

  function onCancel(e) {
    fnSetData('openCookieDialog', false);
    fnSetData('openCookieDrawer', false);
    fnSetData('active', 0);
  }

  function onDrawerOk(e) {
    localStorage.setItem('allow_cookie', 'true');
    fnSetData('openCookieDrawer', false);
    fnSetActiveImage(store['active'])
  }

  function onDrawerCancel(e) {
    fnSetData('openCookieDrawer', false);
    fnSetData('active', 0);
  }

  return (

    <>
      {!isLoading && <div>
        <TopLogo />
        <TopBanner type="register" />
        <div id="register-main">
          {/* {!store['active'] &&
          <img id="registerStep1" src={registerStep1} alt="registerStep1" />
        } */}
          {/* {store['active'] === 1 && */}
          <img style={{ width: "100%" }} id="registerStep14" src={registerStep14} alt="registerStep14" />
          {/* } */}
          {/* {store['active'] === 2 &&
          <img  style={{ width: "100%" }}  id="registerStep13" src={registerStep13} alt="registerStep13" />
        } */}
          <div className="text-[30px] text-center py-[30px]">
            ลงทะเบียนสำหรับ
          </div>
          <div className="grid grid-cols-2 justify-items-stretch text-center">
            <div>
              <img
                src={RegisterMember}
                className={styleMember}
                alt="register-member"
                onClick={() => onClickImage(1)}
              />
              <div className={`text-[28px] ${store['textColorList'][0]}`}>ผู้ใช้งานทั่วไป</div>
            </div>
            <div>
              <img
                src={RegisterShop}
                alt="register-shop"
                className={styleShop}
                onClick={() => onClickImage(2)}
              />
              <div className={`text-[28px] ${store['textColorList'][1]}`}>ร้านค้า</div>
            </div>

          </div>
          <br></br>
          <br></br>
          <br></br>
        </div>
        <div className="footer">
          <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => liff.closeWindow()}>
                ยกเลิก
              </SecondaryButton>
              <PrimaryButton variant="contained" disabled={store['active'] === 0}  className="w-[40%]" onClick={onClickNext}>
                ต่อไป
              </PrimaryButton>
            </Stack>
          </div>
        </div>

        {/*Drawer Allow Cookie*/}
        <Drawer
          anchor="bottom"
          open={store['openCookieDrawer']}
          onClose={toggleDrawer(false)}
        >
          <div className="p-4">
            <div>
              เราใช้คุกกี้เพื่อเพิ่มประสบการณ์ที่ดีของผู้ใช้และวิเคราะห์การเข้าถึง เมื่อท่านกด ‘ยอมรับ’
              ถือว่าท่านยินยอมในการใช้
              <span className="text-blue" onClick={onClickLinkCookie}>
                นโยบายการใช้คุกกี้
              </span>
              ของเราแล้ว
            </div>
            <br />
            <div className="flex flex-row place-content-end gap-1">
              <PrimaryButton variant="contained" onClick={onDrawerOk}>
                ยอมรับ
              </PrimaryButton>
              <SecondaryButton variant="outlined" onClick={onDrawerCancel}>
                ไม่ยอมรับ
              </SecondaryButton>
            </div>
          </div>
        </Drawer>

        {/*Dialog Cookie*/}
        <ConditionDialog title="นโยบายการใช้คุกกี้" open={store['openCookieDialog']} toggle={toggleCookieDialog}
          onOk={onOk}
          onCancel={onCancel}>
          <Cookies />
        </ConditionDialog>
      </div>
      }
    </>
  );
}